



import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

const StepCardInfo = () => import('@/components/Organisms/StepCardInfo/StepCardInfo.vue')
const StepCardInfoContent = () => import('@/components/Molecules/StepCardInfoContent/StepCardInfoContent.vue')

import Categories from "@/constants/category";
import {MilestoneInterface} from "@/share/types/interface";

@Component({
  components: {
    StepCardInfo,
    StepCardInfoContent
  }
})
export default class TreeModalCardInfo extends Vue {
  @Prop({required: false, type: Boolean}) modalVisible !: boolean
  @Prop() data !: any

  private isOpen = false

  @Watch('modalVisible', {immediate: true, deep: true})
  private onModalVisible(modalVisible: boolean): void {
    this.isOpen = modalVisible
  }

  public modalHiddenCallback(): any {
    this.$emit('hidden')
  }

  private get categoryCurrent(): any {
    return (type: number) => {
      const category = Categories.find(o => o.key === type)
      return category ? category : Categories[0]
    }
  }

  private getDataStepHeader(milestone: MilestoneInterface): any {
    return {
      number: milestone.order,
      total: milestone.stepCount,
      name: milestone.milestoneName,
    }
  }
}
